import { useState, useEffect, Fragment } from "react";
import moment from "moment-timezone";
import {
  CommonText,
  CardTitle,
  TableText,
  Container,
  RoundMiniImage,
} from "../../styledComponents/common";
import { WhiteButton } from "../../styledComponents/buttons";
import {
  AssigneesManageImgTextGrid,
  AssigneesManageRoundImage,
} from "../../styledComponents/createProject";
import {
  UpperTableSection,
  UpperColorRecognitionSection,
  UpperColorRecognition,
  ColoredBar,
  ButtonContainer,
  PayrollInfoTable,
  FixedAmountHistoryContainer,
  FixedAmountHistorySingleItemContainer,
  FixedAmountUpperSection,
  FixedAmountNoteSection,
} from "../../styledComponents/payroll";
import { TableItem } from "../../styledComponents/teams";

import { getHoursWithSeconds, globalDateTimeFormat, toHHMMSS } from "../../utils/helper";
import { currencySymbolMap } from "../../utils/currencies";

import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";

import { PayrollSummaryHistory } from "./PayrollSummary";

import avatar5 from "../../assets/img/avatar_5.svg";
import { CommImageNameComp } from "custom_modules/Members/CommonComponents";

const HourlyBasisHistory = ({
  isLoading,
  hourlyHistory,
  selectedProject,
  startDate,
  endDate,
  paymentHistory,
  selectedOrganization,
  orgTimeZone,
}) => {
  return (
    <Container showBorder={true} padding="30px 0">
      {isLoading ? (
        <ComponentCircleLoader />
      ) : hourlyHistory && hourlyHistory.length > 0 ? (
        <>
          <UpperTableSection>
            <CardTitle>
              {selectedProject && selectedProject.value
                ? selectedProject.label
                : "All Projects"}
            </CardTitle>
            <UpperColorRecognitionSection>
              <UpperColorRecognition>
                <ColoredBar />
                <CommonText>Marked as Paid</CommonText>
              </UpperColorRecognition>
            </UpperColorRecognitionSection>
          </UpperTableSection>

          <PayrollSummaryHistory
            type="hourly"
            startDate={startDate}
            endDate={endDate}
            paymentData={paymentHistory}
            selectedOrganization={selectedOrganization}
            orgTimeZone={orgTimeZone}
          />

          {hourlyHistory.map((payrollItem, i) => {
            if (payrollItem.memberList && payrollItem.memberList.length > 0) {
              return (
                <Fragment key={i}>
                  <ButtonContainer index={i}>
                    <WhiteButton
                      type="cancel"
                      bgColor="#f8f9fc"
                      borderColor="#c2cce1"
                      cursor="auto"
                    >
                      {payrollItem.date}
                    </WhiteButton>
                  </ButtonContainer>
                  <PayrollInfoTable header hourly>
                    <TableItem>
                      <UpperColorRecognition>
                        <div></div>
                        <TableText>Member Name</TableText>
                      </UpperColorRecognition>
                    </TableItem>
                    <TableItem>
                      <TableText>Time Worked</TableText>
                    </TableItem>
                    <TableItem>
                      <TableText>Pay Rate</TableText>
                    </TableItem>
                    <TableItem>
                      <TableText>Total Pay</TableText>
                    </TableItem>
                    <TableItem>
                      <TableText>Paid by at</TableText>
                    </TableItem>
                    <></>
                  </PayrollInfoTable>
                  {payrollItem.memberList.map((member, index) => (
                    <PayrollInfoTable key={index} hourly>
                      <TableItem>
                        <UpperColorRecognition>
                          <ColoredBar green={member.paid} />
                          <CommImageNameComp
                            name={member.name}
                            imgSource={member.avatar}
                            size="36px"
                            fontSize="13px"
                            index={index}
                            color={member.color}
                            userId={member.user_id}
                            designation={member.designation}
                            showAddDesignation={false}
                          />
                        </UpperColorRecognition>
                      </TableItem>
                      <TableItem>
                        <TableText name> {getHoursWithSeconds(member.timeWorked)} </TableText>
                      </TableItem>
                      <TableItem>
                        <TableText name>
                          {`${currencySymbolMap[member.currency]} ${
                            member.payRate
                          }`}
                        </TableText>
                      </TableItem>
                      <TableItem>
                        <TableText name>
                          {`${currencySymbolMap[member.currency]} ${
                            member.totalPay
                          }`}
                        </TableText>
                      </TableItem>
                      <TableItem>
                        <TableText name>{member.paidBy}</TableText>
                      </TableItem>
                    </PayrollInfoTable>
                  ))}
                </Fragment>
              );
            }
            return null;
          })}
        </>
      ) : (
        <NoDataComponent title="No payment history found." />
      )}
    </Container>
  );
};

const FixedAmountHistory = ({
  isLoading,
  onetimeHistory,
  selectedProject,
  startDate,
  endDate,
  paymentHistory,
  selectedOrganization,
  orgTimeZone,
}) => {
  return (
    <Container showBorder={true} padding="30px 0">
      {isLoading ? (
        <ComponentCircleLoader />
      ) : onetimeHistory && onetimeHistory.length > 0 ? (
        <>
          <UpperTableSection>
            <CardTitle>
              {selectedProject && selectedProject.value
                ? selectedProject.label
                : "All Projects"}
            </CardTitle>
          </UpperTableSection>

          <PayrollSummaryHistory
            type="fixed"
            startDate={startDate}
            endDate={endDate}
            paymentData={paymentHistory}
            selectedOrganization={selectedOrganization}
            orgTimeZone={orgTimeZone}
          />

          {onetimeHistory.map((payrollItem, i) => {
            if (payrollItem.memberList && payrollItem.memberList.length > 0) {
              return (
                <Fragment key={i}>
                  <ButtonContainer index={i}>
                    <WhiteButton
                      type="cancel"
                      bgColor="#f8f9fc"
                      borderColor="#c2cce1"
                      cursor="auto"
                    >
                      {payrollItem.date}
                    </WhiteButton>
                  </ButtonContainer>
                  <FixedAmountHistoryContainer>
                    {payrollItem.memberList.map((member, index) => (
                      <FixedAmountHistorySingleItemContainer key={index}>
                        <FixedAmountUpperSection>
                          
                          <CommImageNameComp
                            imgSource={member.avatar}
                            name={member.name}
                            size="36px"
                            fontSize="13px"
                            index={index}
                            color={member.color}
                            userId={member.user_id}
                            designation={member.designation}
                            showAddDesignation={false}
                          />
                          <CommonText fontSize="16px" title>{`${
                            currencySymbolMap[member.currency]
                          } ${member.amount}`}</CommonText>
                          <UpperColorRecognition
                            style={{ justifySelf: "flex-end" }}
                          >
                            <ColoredBar green />
                            <CommonText>Payment Done</CommonText>
                          </UpperColorRecognition>
                        </FixedAmountUpperSection>
                        <FixedAmountNoteSection>
                          <CommonText $label>Note</CommonText>
                          <CommonText>{member.note}</CommonText>
                        </FixedAmountNoteSection>
                      </FixedAmountHistorySingleItemContainer>
                    ))}
                  </FixedAmountHistoryContainer>
                </Fragment>
              );
            }
            return null;
          })}
        </>
      ) : (
        <NoDataComponent title="No payroll history found." />
      )}
    </Container>
  );
};

// const CommImageNameComp = (props) => (
//   <AssigneesManageImgTextGrid>
//     <AssigneesManageRoundImage imageSize={props.size}>
//       <RoundMiniImage src={props.imgSource} alt="" imageSize={props.size} />
//     </AssigneesManageRoundImage>
//     <TableText name>{props.name}</TableText>
//   </AssigneesManageImgTextGrid>
// );

const PayrollHistoryTable = ({
  selectedOrganization,
  hourlyPaymentHistory,
  onetimePaymentHistory,
  startDate,
  endDate,
  membersList,
  isLoading,
  historyType,
  setHistoryType,
  sortType,
  selectedProject,
}) => {
  const orgType = selectedOrganization?.type || "operation";
  const orgTimeZone = selectedOrganization?.timezone || moment.tz.guess();
  const [hourlyHistory, setHourlyHistory] = useState([]);
  const [onetimeHistory, setOnetimeHistory] = useState([]);

  useEffect(() => {
    return () => {
      setHistoryType("hourly_basis");
    };
  }, [setHistoryType]);

  useEffect(() => {
    if (hourlyPaymentHistory && hourlyPaymentHistory.length > 0) {
      let history = [];
      getDates().map((date, index) => {
        let object = {};
        object.id = index;
        object.date = moment(date.date).format("ddd, MMMM DD, YYYY");
        let list = [];
        hourlyPaymentHistory.map((item) => {
          const member = membersList.find(
            (member) => member.id === item.paid_to.id
          );
          if (moment(date.date).format("YYYY-MM-DD") === item.paid_for_date) {
            list.push({
              id: item.id,
              name: item.paid_to.name,
              avatar: item.paid_to.avatar ? item.paid_to.avatar : avatar5,
              color: member?.color,
              timeWorked: getHoursWithSeconds(toHHMMSS(item.working_duration)),
              payRate: (item.pay_rate / 100).toFixed(2),
              totalPay: (item.total_pay / 100).toFixed(2),
              currency: item.currency,
              paidBy: `${item.paid_by.name}, ${globalDateTimeFormat(item.paid_at, 'daydate')}`,
              user_id:item.paid_to.id,
            });
          }
        });
        object.memberList = list;
        history.push(object);
      });
      setHourlyHistory(history);
    } else if (
      hourlyPaymentHistory &&
      hourlyPaymentHistory.length === 0
    ) {
      setHourlyHistory([]);
    }
  }, [hourlyPaymentHistory, membersList]);

  useEffect(() => {
    if (onetimePaymentHistory && onetimePaymentHistory.length > 0) {
      let history = [];
      getDates().map((date, index) => {
        let object = {};
        object.id = index;
        object.date = moment(date.date).format("ddd, MMMM DD, YYYY");
        let list = [];
        onetimePaymentHistory.map((item) => {
          const member = membersList.find(
            (member) => member.id === item.paid_to.id
          );
          if (moment(date.date).format("YYYY-MM-DD") === item.paid_at) {
            list.push({
              id: item.id,
              name: item.paid_to.name,
              avatar: item.paid_to.avatar ? item.paid_to.avatar : avatar5,
              color: member?.color,
              amount: (item.paid_amt / 100).toFixed(2),
              currency: item.currency,
              note: item.note,
              user_id:item.paid_to.id,
            });
          }
        });
        object.memberList = list;
        history.push(object);
      });
      setOnetimeHistory(history);
    } else if (
      onetimePaymentHistory &&
      onetimePaymentHistory.length === 0
    ) {
      setOnetimeHistory([]);
    }
  }, [onetimePaymentHistory, membersList]);

  useEffect(() => {
    let presentState;
    if (historyType && historyType === "hourly_basis") {
      presentState = [...hourlyHistory];
      const sortedList = presentState.slice().reverse();
      setHourlyHistory([...sortedList]);
    } else {
      presentState = [...onetimeHistory];
      const sortedList = presentState.slice().reverse();
      setOnetimeHistory([...sortedList]);
    }
  }, [sortType, historyType]);

  const getDates = () => {
    let dates = [];
    let sDate = startDate;
    while (moment(sDate).isSameOrBefore(moment(endDate))) {
      dates.push({
        date: sDate,
      });
      sDate = moment(sDate).add(1, "days");
    }
    return dates;
  };
  if (historyType && historyType === "hourly_basis") {
    return (
      <HourlyBasisHistory
        // hourlyHistoryList={hourlyHistoryList}
        startDate={startDate}
        endDate={endDate}
        paymentHistory={hourlyPaymentHistory}
        hourlyHistory={hourlyHistory}
        selectedOrganization={selectedOrganization}
        selectedProject={selectedProject}
        isLoading={isLoading}
        orgTimeZone={orgTimeZone}
      />
    );
  } else {
    return (
      <FixedAmountHistory
        startDate={startDate}
        endDate={endDate}
        paymentHistory={onetimePaymentHistory}
        onetimeHistory={onetimeHistory}
        selectedOrganization={selectedOrganization}
        selectedProject={selectedProject}
        isLoading={isLoading}
        orgTimeZone={orgTimeZone}
      />
    );
  }
};

export default PayrollHistoryTable;
